import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots'

const json = {
	1: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P33-E1',
		audio: 'Audios/Track 16.mp3',
		component: T6,
		exerciseKey: 'img/FriendsPlus/Page33/E1/Key/E1answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		inputSize: 10,
		textAlign: 'center',
		maxLength: 1,
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 20,
			height: 40,
			width: 40,
		},
		titleQuestion: [
			{
				num: '1',
				title:
					"Write and match. Listen and check. <headphone name='16' src='Audios/Track 16.mp3'></headphone>",
				color: '#234090',
			},
		],
		isHiddenCheck: true,
		questions: [
			{
				title: `

        <div style='position: relative; width:100%; text-align:right' >
            <img style='width:15cm; height: 13cm' src="img/FriendsPlus/Page33/E1/1.jpg" />    
            
            <div style=" position: absolute; top: 306px; left: 25px;">#</div>
            <div style=" position: absolute; top: 453px; left: 46px;">#</div>

            <div style=" position: absolute; top: 161px; left: 452px;">#</div>
            <div style=" position: absolute; top: 306px; left: 450px;">#</div>
            <div style=" position: absolute; top: 452px; left: 439px;">#</div>
            
            </div>
            
          `,
				answer: ['u', 'v', 'p', 't', 'u'],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P33-E2',
		audio: 'Audios/Track 17.mp3',
		component: T6,
		exerciseKey: 'img/FriendsPlus/Page33/E2/Key/E2answerKey.png',
		inputSize: 50,
		textAlign: 'center',
		maxLength: 10,
		isHiddenCheck: true,
		titleQuestion: [
			{
				num: '2',
				title:
					"Write. Listen and chant. <headphone name='17' src='Audios/Track 17.mp3'></headphone>",
				color: '#234090',
			},
		],
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 30,
			height: 50,
			width: 140,
		},
		questions: [
			{
				title: `
       <div style='position:relative'>
       <img src='img/FriendsPlus/Page33/E2/1.jpg' />

        <div style=" position: absolute; top: 107px; left: 657px; ">#</div>
        <div style=" position: absolute; top: 173px; left: 491px; ">#</div>
        <div style=" position: absolute; top: 173px; left: 663px; ">#</div>
        <div style=" position: absolute; top: 237px; left: 415px; ">#</div>
        <div style=" position: absolute; top: 237px; left: 655px; ">#</div>
     
      </div>
            
          `,
				answer: ['van', 'tall', 'vet', 'under', 'umbrella'],
			},
		],
	},
}

export default json
